
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import SelectPeriod from '../../Components/shared/SelectPeriod';
import { PeriodeDashboard} from '../../data/Interfaces';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import { adapter4BackendProxy } from '../../Utils/utilsDashboards';
import { filtreListPeriode } from './DashbordBackOffice';

const Flux = () => {
    const [trafics, setTrafics] = useState([]);
    const [newUser, setNewUser] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const { i18n } = useTranslation();

    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 2);

    const [customDateRange, setCustomDateRange] = useState({
        from: currentDate.toISOString().slice(0, 10), // Get formatted date
        to: new Date().toISOString().slice(0, 10), // Get current date in YYYY-MM-DD format
    });

    const [selectedPeriod, setSelectedPeriod] = useState('custom'); // Default selected period

    const [customDateRange2, setCustomDateRange2] = useState({
        from: currentDate.toISOString().slice(0, 10), // Get formatted date
        to: new Date().toISOString().slice(0, 10), // Get current date in YYYY-MM-DD format
    });

    const [selectedPeriod2, setSelectedPeriod2] = useState('custom'); // Default selected period

    const [chartTraficUser, setChartTraficUser] = useState({
        series: [],

        options: {
            labels: [],
            chart: {
                type: 'area',
                zoom: {
                    enabled: true,
                    //type: 'xy', // Use 'xy' for 2D zoom (x and y-axis) or 'y' for only y-axis zoom
                },
            },
            dataLabels: {
                enabled: false
            },
            fill: {
                opacity: 1,
            },
            yaxis: {
                type: 'numeric', // Specify the type as 'numeric'
                labels: {
                    formatter: function (val) {
                        // Use a formatter function to format the labels as integers
                        return Math.round(val);
                    },
                },
            },
            stroke: {
                curve: 'straight'
            },
        },
    });

    const [chartNewUser, setChartNewUser] = useState({
        series: [],

        options: {
            labels: [],
            chart: {
                type: 'area',
                zoom: {
                    enabled: true,
                    //type: 'xy', // Use 'xy' for 2D zoom (x and y-axis) or 'y' for only y-axis zoom
                },
            },
            dataLabels: {
                enabled: false
            },
            fill: {
                opacity: 1,
            },
            yaxis: {
                type: 'numeric', // Specify the type as 'numeric'
                labels: {
                    formatter: function (val) {
                        // Use a formatter function to format the labels as integers
                        return Math.round(val);
                    },
                },
            },
            stroke: {
                curve: 'straight'
            },
        },
    });

    useEffect(() =>{
        getDataForCandidatureRecuParAO();
    }, []);

    const { setBackdropOpen} = useUtilities();

    const getDataForCandidatureRecuParAO = async () => {
        try {
            // const response1 = await fetch(API_URI_CVTheque + 'getStatistics/'+ encodeURIComponent(temp), {
            //     method: 'Get',
            // });
            setBackdropOpen(true);
            //const [allCandidatures,totalAos,allStatusCandiatures, allMissions,cras,factures,chiffreAffaire,rdvs,trafics] = await adapter4BackendProxy(axiosPrivate,  'getStatistics/None');
            const trafics=await adapter4BackendProxy(axiosPrivate, 'admin/getTraficUsers');
            const newUser=await adapter4BackendProxy(axiosPrivate, 'admin/getNewUsers');
            setTrafics(trafics);
            setNewUser(newUser);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    // Process the data to group by role and calculate counts for createdAt and updatedAt
    const groupData = (data,selectedPeriod,customDateRange,dataField) => {
        var monthYear;
        var result={};

        result=data.reduce((acc, item) => {
            if(dataField=='create')
                monthYear = ((new Date(item.createdAt).getMonth() + 1)+'-'+new Date(item.createdAt).getFullYear());
            else
                monthYear = ((new Date(item.updatedAt).getMonth() + 1)+'-'+new Date(item.updatedAt).getFullYear());

            if (!acc[item.role]) {
                acc[item.role] = { role: item.role, date: {} };
            }

            acc[item.role].date[monthYear] = (acc[item.role].date[monthYear] || 0) + 1;

            return acc;
        }, {});

        // ---Extract the month-year keys and counts for each role---

        const roles = Object.values(result);
        // Initialize an empty object to store unique values of createdAt and updatedAt
        const uniqueDateCounts = {};
        //const uniqueUpdatedAtCounts = {};

        roles.forEach(roleData => {
            const dateCounts = roleData.date;

            // Loop through createdAtCounts and add unique values to the uniqueCreatedAtCounts object
            Object.keys(dateCounts).forEach(monthYear => {
                if (!uniqueDateCounts[monthYear]) {
                    uniqueDateCounts[monthYear] = dateCounts[monthYear];
                } else {
                    uniqueDateCounts[monthYear] += dateCounts[monthYear];
                }
            });
        });
        // Use Object.keys to get an array of the object's keys (month-year)
        const keysMonths = Object.keys(uniqueDateCounts).sort(function(a, b) {
            // Split the strings into arrays and parse them as integers
            var aParts = a.split('-').map(Number);
            var bParts = b.split('-').map(Number);

            // Compare years first
            if (aParts[1] !== bParts[1]) {
                return aParts[1] - bParts[1];
            }
            // If years are the same, compare months
            return aParts[0] - bParts[0];
        });
        //keysMonths.reverse();
        console.log('keysMonths after',keysMonths);

        const seriesValues = roles.map(role => ({
            // name: role.role.toString(),
            name: role.role === 'client' ? 'Client' : role.role === 'expertActif' ? 'Expert Actif' : role.role === 'expertPassif' ? 'Expert Passif' : role.role.toString(),
            data: keysMonths.map(month => role.date[month] || 0)
        }));

        return {seriesValues,keysMonths};

    };

    useEffect(()=>{
        if(Array.isArray(newUser)){
            //const firstFiltrePeriode=filtreListPeriode(allStatusMissions,selectedPeriodMission,customDateRangeMission);
            var filteredData;
            filteredData=newUser;

            if(selectedPeriod)
                filteredData=filtreListPeriode(filteredData,selectedPeriod,customDateRange,'createdAt');

            const {seriesValues,keysMonths}=groupData(filteredData,selectedPeriod,customDateRange,'create');

            console.log('uniqueCreatedAtCounts',keysMonths,'seriesValues',seriesValues);
            //const {periodes,backofficeArrays,selectBOWithoutLastValue}=calculateCAByPeriodeByCr(filteredData,selectedBackOfficeValues);
            //console.log('ListBackOfficeIdsWithoutlALlval',selectBOWithoutLastValue);

            setChartTraficUser((prevState) => {
                return {
                    ...prevState,
                    series:seriesValues,
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: keysMonths
                            //Object.keys(counts)
                            //Array.isArray(CountsListStatusCandidatures) ? CountsListStatusCandidatures.map((item) => item.date) : [],
                        },
                    },
                };
            });
        }
    },[newUser,customDateRange,selectedPeriod]);

    useEffect(()=>{
        if(Array.isArray(trafics)){
            //const firstFiltrePeriode=filtreListPeriode(allStatusMissions,selectedPeriodMission,customDateRangeMission);
            var filteredData;
            filteredData=trafics;

            if(selectedPeriod2)
                filteredData=filtreListPeriode(filteredData,selectedPeriod2,customDateRange2,'updatedAt');

            const {seriesValues,keysMonths}=groupData(filteredData,selectedPeriod2,customDateRange2,'update');

            console.log('uniqueUpdatedAtCounts',keysMonths,'seriesValues',seriesValues);
            //const {periodes,backofficeArrays,selectBOWithoutLastValue}=calculateCAByPeriodeByCr(filteredData,selectedBackOfficeValues);
            //console.log('ListBackOfficeIdsWithoutlALlval',selectBOWithoutLastValue);

            setChartNewUser((prevState) => {
                return {
                    ...prevState,
                    series:seriesValues,
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: keysMonths
                            //Object.keys(counts)
                            //Array.isArray(CountsListStatusCandidatures) ? CountsListStatusCandidatures.map((item) => item.date) : [],
                        },
                    },
                };
            });
        }
    },[trafics,customDateRange2,selectedPeriod2]);

    return (
        <>

            <div
                className='graph1'
                style={{height:'365px',width:'100%'}}
            >
                <h1 className='dashFrame5'>{i18n.t('Nouveaux inscrits à la platforme')}</h1>
                <div className='filtre1'>
                    <div style={{width:'25%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriod}
                            setSelectedPeriod={setSelectedPeriod}
                            setCustomDateRange={setCustomDateRange}
                            listeVal={PeriodeDashboard}
                        />
                    </div>
                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartTraficUser.options}
                        series={chartTraficUser.series}
                        type="area"
                        width={'100%'}
                        height={'85%'}
                    />
                </div>
            </div>

            <div
                className='graph1'
                style={{height:'365px',width:'100%'}}
            >
                <h1 className='dashFrame5'>{i18n.t('Trafic des utilisateurs')}</h1>
                <div className='filtre1'>
                    <div style={{width:'25%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriod2}
                            setSelectedPeriod={setSelectedPeriod2}
                            setCustomDateRange={setCustomDateRange2}
                            listeVal={PeriodeDashboard}
                        />
                    </div>
                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartNewUser.options}
                        series={chartNewUser.series}
                        type="area"
                        width={'100%'}
                        height={'85%'}
                    />
                </div>
            </div>
        </>
    );
};
export default Flux;